import request from "@/utils/request";
const requestUrl = window.env.portalService;

const portal = {
  getHomeMetric: () => request({
    url: `${requestUrl}/api/v1/home/metric`,
    method: "post"
  }),
  getHomeEnergyChart: () => request({
    url: `${requestUrl}/api/v1/home/energyChart`,
    method: "post"
  })
};
export { portal };
